import renderResource from '../resource/render-resource'
import body from './body'
import relatedWidgets from './related-widgets'

import widgetArea from '../widget/widget-area'
import widget from '../widget/widget'
import articleLayoutHeader from '../widgets/general/article-layout-header'
import relatedWidgetsWidget from '../widgets/general/related-widgets'
import relatedContentWidget from '../widgets/general/related-content'
import textWidget from '../widgets/general/text'
import textHeroWidget from '../widgets/general/text-hero'
import productPromo from '../widgets/general/product-promo'

const articleLayoutWidgets = [
  widget(),
  articleLayoutHeader(),
  relatedWidgetsWidget(),
  relatedContentWidget(),
  textWidget(),
  textHeroWidget(),
  productPromo()
]

const createQuery = () => {
  const articleQuery = `...on Article {
    _id
    headline
    sell
    metaTitle
    metaDescription
    shareTitle
    shareDescription
    displayDate
    images {
      hero_5x2_1920 {
        url
        caption
        link
      }
    }
    author {
      name
      biography
      images {
        main_1x1_150 {
          url
        }
      }
    }
    section {
      color1
      color2
      accentColor
      layouts {
        article {
          layout {
            attributes
            cols {
              width
              widgetArea {
                ${widgetArea(articleLayoutWidgets)}
              }
            }
          }
        }
      }
      subNavItems {
        name
        link
      }
    }
    ${body()}
    ${relatedWidgets()}
  }`
  return renderResource(articleQuery)
}

export default createQuery
